<div [attr.active]="active" [hidden]="!active" class="tab-content">
  <ng-content></ng-content>
</div>
